import { Badge, Tooltip } from '@mantine/core';

interface InfoBadgeProps {
	value?: string;
	color?: string;
}

export function InfoBadge({ value, color = 'medepos.2' }: InfoBadgeProps) {
	return (
		<Tooltip label={value} position="bottom-start" offset={4}>
			<Badge color={color} tt={'none'} size={'lg'} radius={'md'} variant={'light'}>
				{value}
			</Badge>
		</Tooltip>
	);
}
